import { useTranslation } from "react-i18next";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import Fab from "@mui/material/Fab";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";
import MenuIcon from "@mui/icons-material/Menu";
import Button from "@mui/material/Button";
import { useEffect, useState } from "react";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ArrowBackIosOutlinedIcon from "@mui/icons-material/ArrowBackIosOutlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import LinearProgress from "@mui/material/LinearProgress";
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import PersonAdd from "@mui/icons-material/PersonAdd";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import CloseIcon from "@mui/icons-material/Close";
import { format, formatDistance, formatRelative, subDays } from "date-fns";
import { Store } from "../../utils/Store";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import PAuthenticationWindow from "./PAuthenticationWindow";
import GroupIcon from "@mui/icons-material/Group";
import { blue, deepOrange, deepPurple, green } from "@mui/material/colors";
import TranslateIcon from "@mui/icons-material/Translate";
const StyledFab = styled(Fab)({
  position: "absolute",
  zIndex: 1,
  top: -15,
  left: 0,
  right: 0,
  margin: "0 auto",
});

export default function MScreen(props) {
  const { t, i18n } = useTranslation();
  const translate = t;
  const [currentLangauge, setCurrentLangauge] = useState("en");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [showAuthScreen, setShowAuthScreen] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (localStorage.getItem("w_lang")) {
      setCurrentLangauge(localStorage.getItem("w_lang"));
    }
  }, []);

  const [date, setDate] = useState("");

  useEffect(() => {
    if (props.enableClock) {
      const intervalId = setInterval(() => {
        var d = new Date();
        setDate(format(d, "dd-MM-yyyy ccc hh:mm:ss aaa"));
      }, 1000);
      return () => clearInterval(intervalId);
    }
  }, [props.enableClock]);

  function handleLoginSucessResponse(authToken) {
    if (
      window.JSBridge &&
      typeof window.JSBridge !== "undefined" &&
      window.JSBridge !== null
    ) {
      let baseUrl = window.JSBridge.getBaseURL();
      getPrivileges(baseUrl, authToken);
    } else {
      getPrivileges("", authToken);
    }
  }

  async function getPrivileges(baseUrl, authToken) {
    try {
      const response = await fetch(baseUrl + "/auth/v1/users/myPrivileges", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + authToken,
        },
      });
      if (response.status === 200) {
        const json = await response.json();
        if (props.setPrivileges) {
          props.setPrivileges(json);
          props.setCurrentUser(Store.parseJwt(authToken).sub);
        }
        console.log(json);
      }
    } catch (e) {
      props.setAlert({
        show: true,
        title: translate("Alert!"),
        message: translate("Something went wrong!"),
      });
    }
  }

  return (
    <Dialog
      disableBackdropClick={!props.dialogMode}
      disableEscapeKeyDown={!props.dialogMode}
      fullScreen={!props.dialogMode}
      fullWidth={true}
      maxWidth={props.maxWidth ? props.maxWidth : "md"}
      open={true}
      onCloseWindow={props.onRedirectToBack}
      onKeyDown={props.onKeyDown}
      onKeyPress={props.onKeyPress}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          props.onRedirectToBack();
        }
      }}
    >
      <AppBar position={props.position ? props.position : "fixed"}>
        <Toolbar variant="dense">
          {props.isMoreMenuEnabled && (
            <IconButton color="inherit" aria-label="more" onClick={handleClick}>
              <MenuIcon />
            </IconButton>
          )}
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {props.title}
          </Typography>
          <Typography display="block">{props.clockPrefix}</Typography>{" "}
          <Typography
            variant="button"
            display="block"
            style={{ paddingLeft: "5px" }}
          >
            {date}
          </Typography>
          {props.onRedirectToBack && (
            <IconButton
              color="inherit"
              aria-label="more"
              onClick={props.onRedirectToBack}
            >
              <CloseIcon />
            </IconButton>
          )}
        </Toolbar>
      </AppBar>
      <DialogContent style={{ padding: 0 }}>
        {props.isLoaderEnabled && <LinearProgress color="secondary" />}
        <div
          style={{
            paddingTop: props.dialogMode ? "10px" : "50px",
            paddingRight: "5px",
            paddingLeft: "5px",
          }}
        >
          {props.content}
        </div>
      </DialogContent>
      {props.enbaleRightAction && (
        <DialogActions>
          {props.enbaleRightAction && (
            <Button
              onClick={props.onRightAction}
              variant="contained"
              color="primary"
            >
              {props.rightAction}
            </Button>
          )}
        </DialogActions>
      )}
      {props.isMoreMenuEnabled && (
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                left: 25,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
        >
          {props.userName && (
            <MenuItem>
              <Avatar sx={{ bgcolor: blue[500] }}>
                {props.userName.charAt(0).toUpperCase()}
              </Avatar>{" "}
              {props.userName}
            </MenuItem>
          )}
          {props.enableSwitchUser && (
            <MenuItem
              onClick={() => {
                setShowAuthScreen(true);
              }}
            >
              <Avatar sx={{ bgcolor: blue[500] }}>
                <AdminPanelSettingsIcon />
              </Avatar>
              {translate("Switch User")}
            </MenuItem>
          )}
          {props.context.storeAdmin.enableShift && (
            <MenuItem
              onClick={() => {
                props.onShiftClose();
              }}
            >
              <Avatar sx={{ bgcolor: blue[500] }}>
                <GroupIcon />
              </Avatar>
              {translate("Shift Close")}
            </MenuItem>
          )}
          <Divider />
          {props.dialogeSideMenuOptions &&
            props.dialogeSideMenuOptions.map(
              (item) =>
                item && (
                  <MenuItem
                    key={item.key}
                    onClick={() => {
                      item.action();
                    }}
                  >
                    <ListItemIcon>
                      <Avatar
                        sx={{
                          bgcolor: item.colour ? item.colour : green[700],
                        }}
                      >
                        {item.icon}
                      </Avatar>
                    </ListItemIcon>
                    {item.label}
                  </MenuItem>
                )
            )}
          <Divider />
          <MenuItem
            onClick={() => {
              setCurrentLangauge(currentLangauge == "ar" ? "en" : "ar");
              i18n.changeLanguage(currentLangauge == "ar" ? "en" : "ar");
              localStorage.setItem(
                "w_lang",
                currentLangauge == "ar" ? "en" : "ar"
              );
            }}
          >
            <ListItemIcon>
              <Avatar sx={{ bgcolor: blue[500] }}>
                <TranslateIcon />
              </Avatar>
            </ListItemIcon>
            {currentLangauge == "ar" ? "English" : "عربي"}
          </MenuItem>
          <Divider />
          <MenuItem
            onClick={() => {
              props.onLogOut();
            }}
          >
            <ListItemIcon>
              <Avatar sx={{ bgcolor: blue[500] }}>
                <Logout />
              </Avatar>
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
      )}
      {showAuthScreen && (
        <PAuthenticationWindow
          context={props.context}
          handleLoginSucessResponse={handleLoginSucessResponse}
          showWindow={setShowAuthScreen}
        ></PAuthenticationWindow>
      )}
    </Dialog>
  );
}
